module.exports = __webpack_public_path__ + "img/company.500f530e.png";